import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/styles';
import {
  TextField,
  Grid,
  CardHeader,
  Divider,
  Button,
  Fab,
  Typography,
  CircularProgress,
} from '@material-ui/core';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import SaveIcon from '@material-ui/icons/Save';
import RTL from '../../../../components/RTL';
import province from './../../../province';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {Loading, showSnackbar} from 'redux/Action';
import {useDispatch, useSelector} from 'react-redux';
import {axios} from './../../../../axios';
import {values} from 'underscore';
const useStyles = makeStyles((theme) => ({
  imageContainer: {
    width: 140,
    height: 140,
    margin: 'auto',
    position: 'relative',
    overflow: 'unset',
  },
  inputBtn: {
    marginTop: theme.spacing(3),
    width: '100%',
  },
  imageButton: {
    position: 'absolute',
    left: -15,
    bottom: -10,
  },
  image: {
    width: 110,
    height: 110,
  },
  input: {
    marginTop: theme.spacing(4),
    width: '100%',
  },
  imageInput: {
    display: 'none',
  },
  divider: {
    opacity: '0.1',
    marginLeft: '25%',
    marginRight: '25%',
    width: '50%',
    alignItems: 'center',
    backgroundColor: '#273c75',
    height: 1,
  },
  submitButtonIcon: {
    marginLeft: theme.spacing(2),
  },
  wrapper: {
    position: 'relative',
    width: '100%',
  },
  buttonProgress: {
    color: '#121E3E',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginLeft: -12,
  },
}));

const Form = (props) => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.token);
  const isLoading = useSelector((state) => state.isLoading);

  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const {data, id, edit, reloadFunc, onClose} = props;

  const classes = useStyles();

  const [error, setError] = React.useState({
    title: '',
    message: '',
  });
  const [value, setValue] = React.useState({
    title: '',
    message: '',
  });

  const handleChange = (e) => {
    const re = /^[0-9\b]+$/;

    let name = e.target.name;
    setError({...error, [name]: ''});
    setValue({...value, [name]: e.target.value});
  };

  const SendNotif = async () => {
    try {
      // alert(JSON.stringify(value));
      const res = await axios.post(`notifications/send-to-all`, {
        title:value.title,
        body:value.message,
      },{
        headers:headers
      });
      dispatch(showSnackbar(true, 'success', 'اعلان با موفقیت ارسال شد'));
      setValue({...value, title: '', message: ''});
      dispatch(Loading());
    } catch (e) {
      dispatch(Loading());
      console.log(e.response, 'eeeeeeeee');
      if (e.response.status === 422) {
        const er = e.response.data.errors;

        let er_keys = Object.keys(er);
        let obj_error = {};
        er_keys.forEach((element) => {
          obj_error[element] = er[element][0];
        });

        setError(obj_error);
      }
    }
  };

  const sendBtn = () => {
    let va_keys = Object.keys(value);

    let obj_empty = {};
    va_keys.forEach((element) => {
      if (value[element] === '') {
        obj_empty[element] = 'این فیلد نمی تواند خالی باشد';
      }
    });

    setError(obj_empty);

    if (Object.keys(obj_empty).length == 0) {
      dispatch(Loading());
      SendNotif();
    } else {
      // alert(JSON.stringify(obj_empty))
    }
  };

  return (
    <RTL>
      {!isLoading ? (
        <>
          <Grid justify="center" container>
            <CardHeader title="ارسال اعلان گروهی جدید" />
            <Divider className={classes.divider} variant="fullWidth" />
          </Grid>

          <Grid container justify="space-between">
            <Grid item xs={12} sm={12}>
              <TextField
                className={classes.input}
                label="عنوان اعلان"
                variant="outlined"
                value={value.title}
                error={Boolean(error?.title)}
                helperText={error?.title}
                onChange={handleChange}
                name="title"
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                multiline
                className={classes.input}
                label="متن اعلان"
                fullWidth
                variant="outlined"
                rows="4"
                value={value.message}
                error={Boolean(error?.message)}
                helperText={error?.message}
                onChange={handleChange}
                name="message"
              />
            </Grid>
          </Grid>

          <div className={classes.wrapper}>
            <Button
              fullWidth
              onClick={() => sendBtn()}
              className={(classes.input, classes.inputBtn)}
              variant="contained"
              disabled={isLoading}
              color="secondary"
              size="large"
              startIcon={<SaveIcon className={classes.submitButtonIcon} />}
            >
              ارسال اعلان
            </Button>
            {isLoading && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </div>
        </>
      ) : (
        <div className={classes.wrapper} style={{padding: 40}}>
          {isLoading && (
            <CircularProgress size={24} className={classes.buttonProgress} />
          )}
        </div>
      )}
    </RTL>
  );
};

export default Form;
